import React, { Component, useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import CommonAlert from "../common/Commonalert";
import Sidebar from "../common/sidebar";
import ShowAlert from "../common/Showalert";
import { useTranslation } from "react-i18next";

const IngredientsAdd = () => {
  const { t } = useTranslation();
  const [ingredients_txt, setIngredients_Txt] = useState([]);
  const [errormsg, setErrormsg] = useState({});
  const [errmessage, setErrMessage] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alerterrMessage, setAlerterrMessage] = useState([]);
  const [ingredientslist, setIngredientslist] = useState([]);

  const routeChange = () => {
    window.location.href = "/ingredients";
  };

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_settings")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL = BaseUrl + "admin/ingredientlist";
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;

        setIngredientslist(responseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const btnsubmit = (e) => {
    e.preventDefault();
    const isValid = formvalidation();
    if (isValid) {
      let ingredientstxt = ingredients_txt.trim().toUpperCase();
      let payload = {
        ingredientTitle: ingredientstxt,
      };
      const isFound = ingredientslist.some((element) => {
        if (element.ingredientTitle === ingredientstxt) {
          return true;
        }
        return false;
      });
      if (isFound) {
        setAlertErrorPopup(true);
        setAlerterrMessage(t("ingredient_already_added_txt"));
      } else {
        var loginDetails = {};
        if (sessionStorage.getItem("authData")) {
          loginDetails = JSON.parse(sessionStorage.getItem("authData"));
        }
        let URL = BaseUrl + "admin/ingredient/";
        http
          .post(URL, payload)
          .then(async (response) => {
            if (response.data.success === true) {
              setAlertPopup(true);
              setAlertMessage(t("ingredient_added_successfully_txt"));
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const formvalidation = () => {
    const errmessage = {};
    const errmsg = {};
    let isValid = true;
    if (ingredients_txt == "") {
      errmessage.ingredientstxterr = t("field_required_txt");
      errmsg.ingretxt = true;
      isValid = false;
    }
    if (isValid) {
      errmessage.ingredientstxterr = "";
      errmsg.ingretxt = false;
      setErrMessage(errmessage);
      return isValid;
    } else {
      setErrMessage(errmessage);
      setErrormsg(errmsg);
      return isValid;
    }
  };

  const handleOnChange = (e) => {
    const re = /^[a-zA-Z][a-zA-Z ]*$/;
    if (e.target.name === "ingredients_txt") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setIngredients_Txt(e.target.value);
      }
      if (errmessage.ingredientstxterr != "") {
        errormsg.ingretxt = false;
      }
      setErrormsg(errormsg);
    }
  };

  return (
    <section className="dashboard-block">
      {alerterrorPopup && <ShowAlert title={t("alert_txt")} message={alerterrMessage} />}
      {alertPopup && <CommonAlert title={t("alert_txt")} message={alertMessage} />}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">{t("add_ingredient_txt")}</h1>
            <div className="right-table-outer-wrap">
              <div className="form-field freeproduct-fieldset ingredients-fieldset form-container-xs">
                <form className="client-detail-form">
                  <div className="input-field col-1">
                    <label htmlFor="name">{t("ingredientt_txt")}</label>
                    <input
                      type="text"
                      name="ingredients_txt"
                      value={ingredients_txt}
                      onChange={handleOnChange}
                    />
                    {errormsg.ingretxt && (
                      <div className="error-msg">
                        {errmessage.ingredientstxterr}
                      </div>
                    )}
                  </div>
                  <div className="btnfield">
                    <button title={t("submit_txt")} type="submit" name="btnsubmit" onClick={btnsubmit}>
                      {t("submit_txt")}
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button title={t("cancel_txt")} type="button" onClick={routeChange}>
                      {t("cancel_txt")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};

export default IngredientsAdd;
